module.exports = class DealsFeaturedImageCarousel
  constructor: ({el}) ->
    @carouselWidget = el if el?.length
    @images = @carouselWidget?.find('img')

    return {} unless @images?.length

    @size = @images.length - 1
    @position = 0

    @initializeCarousel()

  initializeCarousel: ->
    # Display first image
    firstImage = @images[0]
    $(firstImage).show()

    # Load controls
    @carouselWidget.find('.icon-arrow-left-large').on 'click', (e) =>
      @slide 'left'

    @carouselWidget.find('.icon-arrow-right-large').on 'click', (e) =>
      @slide 'right'

  slide: (direction) ->
    @updateCarousel @nextPosition direction

  nextPosition: (direction) ->
    if direction is 'left'
      if @position > 0
        @position - 1
      else
        @size
    else
      if @position < @size
        @position + 1
      else
        0

  updateCarousel: (nextPosition) ->
    return if @position is nextPosition
    @updateSlide @position, nextPosition
    @position = nextPosition

  updateSlide: (currentPosition, nextPosition) ->
    currentImage = @images[currentPosition]
    nextImage = @images[nextPosition]
    $(currentImage).hide()
    $(nextImage).show()
